"use client";

import React, { useState } from "react";
import { Box, Typography, Container, Grid, IconButton, Dialog, DialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FaPlay } from "react-icons/fa";
// import { PlayCircle } from 'lucide-react';
import Animator from "../../../components/Aminator/Animator";
import { useIsMobile } from "../../../components/hooks/useIsMobile";
import image from "../../../assets/images/image 4.png"

// Styled components
const SectionContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
}));

const ContentContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(6, 2),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(8, 2),
  },
}));

const VideoContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: "500px",
  overflow: "hidden",
  cursor: "pointer",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1,
  },
}));

const PlayButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#E25822",
  color: "#FFFFFF",
  width: 80,
  height: 80,
  zIndex: 2,
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#C24812",
    transform: "translate(-50%, -50%) scale(1.1)",
  },
}));

function VideoSection() {
  const mobile = useIsMobile();
  const [videoOpen, setVideoOpen] = useState(false);

  const handleOpenVideo = () => {
    setVideoOpen(true);
  };

  const handleCloseVideo = () => {
    setVideoOpen(false);
  };

  return (
    <SectionContainer>
      {/* Text Content */}
      <ContentContainer maxWidth="lg">
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Animator variant="fade" delay={300} timeout={500}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: mobile ? "1.8rem" : "2.3rem",
                  fontWeight: 600,
                  color: "#141F39",
                  lineHeight: 1.2,
                }}
              >
                Partner with E1X for Excellence
              </Typography>
            </Animator>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Animator variant="fade" delay={400} timeout={500}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Monserrat, sans-serif",
                  color: "#4A5568",
                  lineHeight: 1.7,
                  fontSize: "1rem",
                }}
              >
                At E1X, we understand that every role is critical to your business success. Our platform combines advanced matching technology with expert human insights.
              </Typography>
            </Animator>
          </Grid>
        </Grid>
      </ContentContainer>

      {/* Video Section */}
      <Animator variant="fade" delay={500} timeout={500}>
        <VideoContainer onClick={handleOpenVideo}>
          <Box
            component="img"
            src={image}
            alt="Consultancy team working together"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <PlayButton aria-label="Play video">
            <FaPlay size={40} />
          </PlayButton>
        </VideoContainer>
      </Animator>

      {/* Video Dialog */}
      <Dialog
        open={videoOpen}
        onClose={handleCloseVideo}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent sx={{ p: 0, backgroundColor: "#000000" }}>
          <Box
            component="iframe"
            src="https://www.youtube.com/embed/dQw4w9WgXcQ" // Replace with your actual video URL
            title="EIX Consultancy Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            sx={{
              width: "100%",
              height: "70vh",
              border: "none",
            }}
          />
        </DialogContent>
      </Dialog>
    </SectionContainer>
  );
}

export default VideoSection;